import { calculateMedicalStatusCounts } from "./calculateUserMedicalStatus";

const UserListReportSummary = ({ userList }) => {
  const { fit, unfit, heldUp, others, total } =
    calculateMedicalStatusCounts(userList);
  return (
    <div>
      <div className="patient-info-table-search">
        <div className="fit-unfit-status">
          <span className="fw-bolder">Record Summary &gt; </span>
          <span className="text-success fw-bolder">{`FIT: ${fit}`}</span>
          <span> | </span>
          <span className="text-danger fw-bolder">{`UNFIT: ${unfit}`}</span>
          <span> | </span>
          <span className="fw-bolder" style={{ color: "#0000FF" }}>
            {`HELD-UP: ${heldUp}`}
          </span>
          <span> | </span>
          <span className="fw-bolder">{`Others: ${others}`}</span>
          <span> | </span>
          <span className="fw-bolder">{`Total: ${total}`}</span>
        </div>
        <div className="reg-summary d-flex justify-content-end">
          <span className="me-1">Summary Of:</span>{" "}
          <span
            className="text-primary"
            data-bs-toggle="modal"
            data-bs-target="#country-summary-modal"
          >
            Country
          </span>{" "}
          <span className="mx-1">|</span>
          <span
            className="text-primary"
            data-bs-toggle="modal"
            data-bs-target="#agency-summary-modal"
          >
            Agency
          </span>{" "}
          <span className="mx-1">|</span>
          <span
            className="text-primary"
            data-bs-toggle="modal"
            data-bs-target="#repres-summary-modal"
          >
            Representative
          </span>{" "}
          <span className="mx-1">|</span>
          <span
            className="text-primary"
            data-bs-toggle="modal"
            data-bs-target="#package-summary-modal"
          >
            Package
          </span>
        </div>
      </div>
    </div>
  );
};

export default UserListReportSummary;
